import { h } from "preact";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import MainLayout from "./layouts/MainLayout";
import AccountPage from "./pages/Account/AccountPage";
import DashboardPage from "./pages/Dashboard/DashboardPage";
import DocumentationPage from "./pages/Documentation/DocumentationPage";
import FPEPage from "./pages/Fpe/FPEPage.jsx"
import MembersPage from "./pages/Members/MembersPage";
import PageNotFound from "./pages/PageNotFound/PageNotFound";
import SettingsPage from "./pages/Settings/SettingsPage";
import SupportPage from "./pages/Support/SupportPage";
import TransactionInfoPage from "./pages/Transactions/TransactionInfoPage";
import TransactionsPage from "./pages/Transactions/TransactionsPage";
import LoginPage from "./pages/Login/MockLoginPage";
import BlacklistPage from "./pages/Blacklist/Blacklist";
import { KeycloakProvider } from "./providers/KeycloakProvider";
import FlowsPage from "./pages/Flows/FlowsPage"


export default function App() {

    return (
        <KeycloakProvider>
            <BrowserRouter>
                <Routes>
                    <Route
                        path="/"
                        element={<MainLayout />}
                    >
                        <Route
                            index
                            element={<DashboardPage />}
                        />
                        <Route
                            path="transactions"
                            element={<TransactionsPage />}
                        />
                        <Route
                            path="transactions/:flow_id"
                            element={<TransactionInfoPage />}
                        />
                        <Route path="flows" element={<FlowsPage />} />
                        <Route
                        path="blacklist"
                        element={<BlacklistPage />}
                    />
                        {/* <Route
                            path="manual_review"
                            element={<ManualReviewPage />}
                        />
                        <Route
                            path="manual_review/:person_id"
                            element={<ManualReviewPersonPage />}
                        /> */}
                        <Route
                            path="account"
                            element={<AccountPage />}
                        />
                        <Route
                            path="members"
                            element={<MembersPage />}
                        />
                        <Route
                            path="settings"
                            element={<SettingsPage />}
                        />
                        <Route
                            path="fpe"
                            element={<FPEPage />}
                        />
                    </Route>
                    <Route
                        path="/login"
                        element={<LoginPage />}
                    />
                    <Route
                        path="/documentation"
                        element={<DocumentationPage />}
                    />
                    <Route
                        path="/support"
                        element={<SupportPage />}
                    />
                    <Route
                        path="*"
                        element={<PageNotFound />}
                    />
                </Routes>
            </BrowserRouter>
        </KeycloakProvider>
    );
}